import { memo, useMemo } from "react"
import { Security, SecurityCategory_CategoryCode } from '../../proto/generated/security'
import { Box } from "@mui/material"
import { getSecurityKey } from "../../util/security"
import { selectOrderBook } from "../../selectors/security"
import { useSelector } from "react-redux"
import { toLocaleStringIn } from "../../util/general"
import OrderBookItem from "../orderBook/OrderBookItem"
import { formatLargeNumber } from "../../util/screener"
import { formatUnixTimestampForOrderBook } from "../../util/dateTime"

export type OrderBookOverviewProps = {
    security: Security
}

const OrderBookOverview: React.FC<OrderBookOverviewProps> = ({ security }) => {

    const securityKey = useMemo(() => security ? getSecurityKey(security.exchange, security.code) : '', [security])
    const orderBook = useSelector(selectOrderBook(securityKey))

    if (!orderBook) return null;

    return <Box display="flex" flexDirection="row" gap={1} justifyContent="space-between" width="100%">
        <Box width="50%">
            <OrderBookItem title={'Open'}
                value={toLocaleStringIn(orderBook.open / (security?.priceMultiplier ?? 100))} />

            <OrderBookItem title={'Low'}
                value={toLocaleStringIn(orderBook.low / (security?.priceMultiplier ?? 100))} />
            {
                security.categoryCode === SecurityCategory_CategoryCode.INDEX ? null :
                <>
                    <OrderBookItem title={'Volume'}
                        value={formatLargeNumber(orderBook.volumeTradedToday)} />
                    <OrderBookItem title={'Lower Circuit'}
                        value={toLocaleStringIn(orderBook.lowerCircuit / (security?.priceMultiplier ?? 100))} />
                </>
            }
        </Box>
        <Box width="50%">
            <OrderBookItem title={'High'}
                value={toLocaleStringIn(orderBook.high / (security?.priceMultiplier ?? 100))} />
            <OrderBookItem title={'Prev. Close'}
                value={toLocaleStringIn(orderBook.close / (security?.priceMultiplier ?? 100))} />
            {
                security.categoryCode === SecurityCategory_CategoryCode.INDEX ? null :
                <>
                    <OrderBookItem title={'LTT'}
                        value={orderBook.lastTradedTime ? formatUnixTimestampForOrderBook(orderBook.lastTradedTime) : '-'} />
                    <OrderBookItem title={'Upper Circuit'}
                        value={toLocaleStringIn(orderBook.upperCircuit / (security?.priceMultiplier ?? 100))} />
                </>
            }
        </Box>
    </Box>
}


export default memo(OrderBookOverview);